export default __webpack_public_path__ + "static/media/fridge1-after2-480w.35e15575.avif";